import { useState } from 'react';
import './styles.css';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import 'react-tabs/style/react-tabs.css';
import { InputText } from 'primereact/inputtext';
import api from 'src/services/api';

export default function CadastroUsuario(props) {
  const [nome] = useState('');
  const [nomeUsuario] = useState('');
  const [senha] = useState('');
  const [permissao, setPermissao] = useState('');

  const handleCriarUsuario = async () => {
    try {
      const response = await api.post('/api/criarUsuario', {
        nome,
        nomeUsuario,
        senha,
        permissao,
      });

      if (response.data.success) {
        alert('Usuário criado com sucesso!');
      } else {
        alert('Erro ao criar usuário. Por favor, tente novamente.');
      }
    } catch (error) {
      console.error('Erro:', error);
      alert(
        'Ocorreu um erro ao criar o usuário. Por favor, tente novamente mais tarde.',
      );
    }
  };

  const breadcrumbItems = [
    { label: 'Configurações', url: '/configuracoes' },
    { label: 'Usuário', url: '/usuario' },
    { label: 'Cadastro de Usuário', url: '/cadastro-de-usuario' },
  ];

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <BreadCrumb
        model={breadcrumbItems}
        home={{ label: 'Home', url: '/' }}
        style={{
          marginTop: '41px',
          marginRight: '600px',
          border: 'none',
          color: '#B7D400!important',
        }}
      />

      <p
        style={{
          fontSize: '35px',
          fontStyle: 'normal',
          fontWeight: '700',
          color: '#006998',
          marginTop: '-15px',
        }}
      >
        Cadastro de Usuário
      </p>
      <div
        style={{ width: '1000px', display: 'flex', justifyContent: 'center' }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1372"
          height="10"
          viewBox="0 0 1372 10"
          fill="none"
        >
          <g filter="url(#filter0_d_110_89)">
            <path
              d="M4 1L1368 1.00012"
              stroke="#006998"
              stroke-opacity="0.55"
              stroke-width="2"
              shape-rendering="crispEdges"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_110_89"
              x="0"
              y="0"
              width="1372"
              height="10"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.521615 0 0 0 0 0.521615 0 0 0 0 0.521615 0 0 0 0.15 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_110_89"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_110_89"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
      <fieldset
        style={{
          width: '1000px',
          minHeight: '250px',
          height: '350px',
          border: '1px solid #006998',
          marginTop: '35px',
          fontWeight: 'bold',
          color: 'black',
          borderRadius: '8px',
        }}
      >
        <legend style={{ fontSize: '20px', fontWeight: 400, color: 'black' }}>
          Informações do usuário
        </legend>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ flex: '1', marginRight: '20px' }}>
              <p style={{ marginTop: '10px', fontWeight: '400' }}>Nome </p>
              <InputText
                style={{
                  width: '100%',
                  display: 'flex',
                  marginTop: '-10px',
                  borderColor: '#006998',
                  fontStyle: 'italic',
                }}
                placeholder="Insira aqui o nome do cliente"
              />
            </div>
            <div style={{ flex: '1' }}>
              <p style={{ marginTop: '10px', fontWeight: '400' }}>
                Nome de Usuário
              </p>
              <InputText
                style={{
                  width: '100%',
                  display: 'flex',
                  marginTop: '-10px',
                  borderColor: '#006998',
                  fontStyle: 'italic',
                }}
                placeholder="Insira aqui o nome de usuário utlizado para login"
              />
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ flex: '1', marginRight: '20px' }}>
              <p style={{ marginTop: '10px', fontWeight: '400' }}>Senha</p>
              <input
                type="password"
                style={{
                  width: '100%',
                  height: '45px',
                  borderRadius: '6px',
                  display: 'flex',
                  marginTop: '-10px',
                  borderColor: '#006998',
                  fontStyle: 'italic',
                }}
                placeholder=""
              />
            </div>
            <div style={{ flex: '1', position: 'relative' }}>
              <p style={{ marginTop: '10px', fontWeight: '400' }}>Permissões</p>
              <div style={{ position: 'relative' }}>
                <select
                  style={{
                    width: '100%',
                    height: '45px',
                    display: 'flex',
                    marginTop: '-10px',
                    fontSize: '14px',
                    fontStyle: 'italic',
                    borderRadius: '5px',
                    borderColor: '#006998',
                    paddingRight: '30px',
                  }}
                  value={permissao}
                  onChange={(e) => setPermissao(e.target.value)}
                >
                  <option value="">
                    Selecione as permissões para o usuário
                  </option>
                  <option value="permissao1">Ata 1</option>
                  <option value="permissao2">Atas 2</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '30px',
          }}
        >
          <Button
            label="Cancelar"
            className="p-button-outlined p-button-primary"
            style={{ marginLeft: '10px', color: 'red' }}
          />
          <Button
            label="Criar Usuário"
            className="p-button-outlined p-button-primary"
            style={{
              marginLeft: '10px',
              color: '#FFF',
              backgroundColor: '#3900DB',
            }}
            onClick={handleCriarUsuario}
          />
        </div>
      </fieldset>
    </div>
  );
}
